const attendanceList = {
  title: "Anwesenheitsliste",
  weekLabel: "KW {{week}}/{{year}}",
  readOnlyNote: "Nur-Ansicht — Eintragen & Ändern erfolgt über den Kalender-Eintrag „Anwesenheit planen“.",
  // The table lists every active staff member regardless of entries, so a resolved-but-empty result
  // means "there are no active staff members" — not "this week has no entries". Only rendered once
  // the query has resolved (see AttendanceTable's showEmptyMessage).
  empty: "Keine aktiven Mitarbeiter:innen vorhanden.",
  filter: {
    label: "Nach Kürzel filtern",
    allAppointmentPurposes: "Alle Termine",
    allAttendancePurposes: "Alle Anwesenheiten",
    allLocations: "Alle Orte",
    allCounselors: "Alle Berater:innen",
    appointmentPurposeAriaLabel: "Nach Termin-Zweck filtern",
    attendancePurposeAriaLabel: "Nach Anwesenheits-Zweck filtern",
    locationAriaLabel: "Nach Ort filtern",
  },
  columns: {
    name: "Name",
    userCode: "Kürzel",
  },
  cell: {
    // The attendance tag ("Büro", "Mobil") is not a key: it is the purpose name minus its
    // "Anwesenheit " prefix, so a newly created attendance purpose labels itself.
    reachableFrom: "erreichbar ab {{date}}",
    substitute: "Vertretung: {{userCode}}",
  },
};

export default attendanceList;
